import {
  getOrganisation_organisation_caseItems,
  getOrganisation_organisation_rentals_rentals,
} from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

export enum DashboardNavigationCardIconEnum {
  CaseItems,
  Depots,
  Employees,
  Invoices,
  PhonePlans,
  Rentals,
}

export type DashboardNavigationCardProps = {
  caseItems?: getOrganisation_organisation_caseItems
  e2eSelector: string
  icon: DashboardNavigationCardIconEnum
  rentals: getOrganisation_organisation_rentals_rentals[] | null
  stocklistItemCount?: number
  title: string
  total: number
  url: string
}
